import React from 'react';
import { MedicalDataTypes } from '../../../primary-record-types';
import { getDisplayRange, hasFullReferenceRange } from '../../../utils/medicalDataUtils';
import SizedView from '../../v2BaseComponents/SizedView';
import ValueIndicator from './ValueIndicator';
import { View } from 'react-native';
import { colors } from '../../../utils/theme';

export type LabValueRangeBarOwnProps = {
    labValue: MedicalDataTypes.LabValue;
};

export type LabValueRangeBarProps = LabValueRangeBarOwnProps;

const VIEW_HEIGHT = 50;
const INDICATORSIZE = 10;
const BAR_HEIGHT = 10;

const LabValueRangeBar: React.FC<LabValueRangeBarProps> = ({ labValue }) => {
    if (!hasFullReferenceRange(labValue)) {
        return null;
    }

    const { min, max, minCut, maxCut, value } = getDisplayRange(labValue);
    const fullRange = max - min;

    const leftRound = {
        borderBottomLeftRadius: BAR_HEIGHT / 2,
        borderTopLeftRadius: BAR_HEIGHT / 2,
    };

    const rightRound = {
        borderTopRightRadius: BAR_HEIGHT / 2,
        borderBottomRightRadius: BAR_HEIGHT / 2,
    };

    const hasLeft = minCut > min;
    const hasRight = maxCut < max;

    const renderBar = () => {
        return (
            <View
                style={{
                    height: BAR_HEIGHT,
                    position: 'relative',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: '100%',
                }}
            >
                <View
                    style={{
                        position: 'absolute',
                        height: '100%',
                        width: `${((minCut - min) / fullRange) * 100}%`,
                        top: 0,
                        backgroundColor: colors['Primary-Reg'],
                    }}
                    {...leftRound}
                    testID="range-bar-left"
                />
                <View
                    style={{
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: colors['Success'],
                        left: `${((minCut - min) / fullRange) * 100}%`,
                        width: `${((maxCut - minCut) / fullRange) * 100}%`,
                        top: 0,
                    }}
                    testID="range-bar-middle"
                    {...(!hasLeft ? leftRound : {})}
                    {...(!hasRight ? rightRound : {})}
                />
                <View
                    style={{
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: colors['Primary-Reg'],
                        right: 0,
                        width: `${((max - maxCut) / fullRange) * 100}%`,
                        top: 0,
                    }}
                    {...rightRound}
                    testID="range-bar-right"
                />
            </View>
        );
    };

    return (
        <SizedView
            style={{
                height: VIEW_HEIGHT,
                width: '100%',
                marginTop: 5,
                marginBottom: 2,
            }}
        >
            {({ width }) => (
                <>
                    <ValueIndicator
                        containerWidth={width}
                        labValue={labValue}
                        height={VIEW_HEIGHT - BAR_HEIGHT}
                        valuePercentage={(value - min) / fullRange}
                        indicatorSize={INDICATORSIZE}
                    />
                    {renderBar()}
                </>
            )}
        </SizedView>
    );
};

export default React.memo(LabValueRangeBar);
